import { GET_ALL_KMZ, GET_ALL_KMZ_WITH_FILTERS } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
import { logout } from '../../../common/functions/log_out.function';

export const getAllKmzsWithFilters = async (ids, names, network, partner, regions, cities) => {
  try {
    const resp = await apiClient.get(
      GET_ALL_KMZ_WITH_FILTERS(ids, names, network, partner, regions, cities),
      {}
    );
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
